const ArmorUse = require('../ability_trees/ArmorUse');
const MeleeCombat = require('../ability_trees/MeleeCombat');
const Movement = require('../ability_trees/Movement');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator');
const HeavyHelmet = require('../../game_items/equipment/helmet/HeavyHelmet');
const HeavyTorsoe = require('../../game_items/equipment/torsoe/HeavyTorsoe');
const HeavyBoots = require('../../game_items/equipment/boots/HeavyBoots');
const Sword = require('../../game_items/equipment/weapon/Sword');
const Shield = require('../../game_items/equipment/off_hand/Shield');

module.exports = {
  handle: 'knight',
  getAbilityTrees: () => ([
    ArmorUse,
    MeleeCombat,
    Movement,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 5,
    perception: 7,
    mana: 4,
    toughness: 10,
    strength: 10,
    willpower: 5,
    dexterity: 9,
  }),
  getDefaultAIConfig: () => (['tank', 'dps_close', 'interference', 'support', 'dps_ranged']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(HeavyHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(HeavyTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(HeavyBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Sword, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Shield, 0, 0.1, true),
  }),
};
